import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { InventoryEffects } from '@inventory/effects/inventory.effects';
import { EffectsModule } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';
import { AddToInventoryComponent } from './components/inventory-modals/add-to-inventory/add-to-inventory.component';
import { CreateInventoryPageRoutingModule } from './create-inventory-routing.module';
import { CreateInventoryPage } from './create-inventory.page';
import { CreateInventoryService } from './services/create-inventory.service';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { PopulateInventoryDesktopTabletComponent } from './components/inventory-modals/populate-inventory/populate-inventory-desktop-tablet/populate-inventory-desktop-tablet.component';
import { PopulateInventoryMobileComponent } from './components/inventory-modals/populate-inventory/populate-inventory-mobile/populate-inventory-mobile.component';
import { AddItemsManuallyComponent } from './components/inventory-modals/populate-inventory/shared/populate-inventory-actions/add-items-manually/add-items-manually.component';
import { PastInventoriesComponent } from './components/inventory-modals/populate-inventory/shared/populate-inventory-actions/past-inventories/past-inventories.component';
import { PastPurchasesComponent } from './components/inventory-modals/populate-inventory/shared/populate-inventory-actions/past-purchases/past-purchases.component';
import { ShoppingListsComponent } from './components/inventory-modals/populate-inventory/shared/populate-inventory-actions/shopping-lists/shopping-lists.component';
import { PopulateInventoryOptionsComponent } from './components/inventory-modals/populate-inventory/shared/populate-inventory-options/populate-inventory-options.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    SharedModule,
    TranslateModule,
    CreateInventoryPageRoutingModule,
    EffectsModule.forFeature([InventoryEffects]),
  ],
  declarations: [
    CreateInventoryPage,
    PopulateInventoryDesktopTabletComponent,
    PopulateInventoryMobileComponent,
    PopulateInventoryOptionsComponent,
    PastInventoriesComponent,
    ShoppingListsComponent,
    PastPurchasesComponent,
    AddItemsManuallyComponent,
    AddToInventoryComponent,
  ],
  providers: [DatePipe, CreateInventoryService],
})
export class CreateInventoryPageModule {}
